import {
  Component,
  computed,
  inject,
  input,
  Input,
  InputSignal,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { MeasurementDetails } from "@app/models/commissioning-mapped-data.interface";
import {
  CommissioningElectricitySimpleMeasurementDetails,
  CommissioningElectricitySystems,
} from "@app/models/form-data.interface";
import { ROUTES } from "@app/models/routes.enum";
import { TEST_ID } from "@app/modules/commissioning-electricity/customer-facility/commissioning-electricity-systems/test-ids";
import { SYSTEM_TYPE_ID_BY_SYSTEM_TYPE } from "@app/modules/common-steps/summary/commissioning/customer-facility-summary/test-ids";
import { CommissioningFormMapperService } from "@app/services/commissioning-form-mapper.service";

@Component({
  selector: "app-customer-facility-summary",
  templateUrl: "./customer-facility-summary.component.html",
  standalone: false,
})
export class CustomerFacilitySummaryComponent {
  public electricitySystems: InputSignal<CommissioningElectricitySystems> =
    input.required();
  @Input({ required: true })
  public meterChanges!: boolean;
  @Input({ required: true })
  public simpleMeasurementDetails?: CommissioningElectricitySimpleMeasurementDetails;
  @Input({ required: true })
  public complexMeasurementDetails?: MeasurementDetails[];

  #translateService = inject(TranslateService);
  #commissioningFormMapperService = inject(CommissioningFormMapperService);
  public readonly electricitySystemsRoute: ROUTES =
    ROUTES.COMMISSIONING_ELECTRICITY_SYSTEMS;
  public local = this.#translateService.currentLang;

  public selectedSystems = computed(() => {
    return this.#commissioningFormMapperService.mapElectricitySystems(
      this.electricitySystems(),
    );
  });

  protected readonly SYSTEM_TYPE_TEST_ID = SYSTEM_TYPE_ID_BY_SYSTEM_TYPE;
  protected TEST_ID = TEST_ID;
}
